import { gql } from '__generated__'

/** Demo Bull's Eye rounds of the guest session (FE-310; the mode itself is FE-311). */
export const GET_DEMO_BULLSEYE_QUOTA = gql(`
  query getDemoBullseyeQuota {
    getDemoBullseyeQuota {
      enabled
      roundsPlayed
      roundsLeft
      canPlay
    }
  }
`)
